/* eslint-disable */
import { StyleSheet, View, Text } from 'react-native';
import ScreenWrapper from '../../components/ScreenWrapper';
import { GooglePlacesAutocomplete } from 'react-native-google-places-autocomplete';
import { useEffect, useState } from 'react';
import { colors, radii, shadows, spacing, typography, card } from '../../config/theme';
import SearchIcon from '../../assets/Search.svg';
import { GOOGLE_MAPS_API_KEY } from '../../config/apis';

const SearchScreen = ({ navigation,route }) => {
  const [searchError, setSearchError] = useState(null);
  const {onSelectLocation} = route.params;
  // Temporary: shows which key the app really uses (last 4 characters only),
  // so we can tell whether the new key was picked up. Remove after testing.
  console.log('places key ends with:', String(GOOGLE_MAPS_API_KEY).slice(-4));
  // Temporary: the same request the browser test made, sent from the app.
  // It tells us if the app can reach Google and what Google answers here.
  useEffect(() => {
    const k = String(GOOGLE_MAPS_API_KEY);
    // A key with a hidden space/newline/quote breaks the URL.
    console.log('places key length:', k.length, 'clean:', k === k.trim() && /^[A-Za-z0-9_-]+$/.test(k));
    fetch(
      `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=utrecht&key=${encodeURIComponent(k.trim())}`,
    )
      .then(r => r.json())
      .then(j =>
        console.log(
          'places test:',
          j.status,
          j.error_message,
          'results:',
          j.predictions?.length,
        ),
      )
      .catch(e => console.log('places test network error:', String(e)));
  }, []);
  return (
    <ScreenWrapper
      isBackButton={true}
      Heading={'Search'}
      onBack={() => navigation.goBack()}
      // The suggestion list is a FlatList, so this screen must not sit
      // inside the wrapper's ScrollView.
      scrollable={false}
    >
      <View style={styles.container}>
        {/* Above the search box: the list below takes all the free height, so
            a message placed under it would never be visible. */}
        {searchError ? (
          <View style={styles.errorContainer}>
            <Text style={styles.errorText}>{searchError}</Text>
          </View>
        ) : null}
        <GooglePlacesAutocomplete
          // Required props
          placeholder="Search"

          autoFocus={true}
          
          query={{
            key: GOOGLE_MAPS_API_KEY, // defined once in src/config/apis.js
            language: 'en',
          }}
          // All other default props explicitly defined
          autoFillOnNotFound={false}
          currentLocation={false}
          currentLocationLabel="Current location"
          debounce={0}
          
          enableHighAccuracyLocation={true}
          enablePoweredByContainer={true}
          isRowScrollable={true}
          keyboardShouldPersistTaps="always"
          listUnderlayColor={colors.surfaceMuted}
          listViewDisplayed="auto"
          keepResultsAfterBlur={false}
          minLength={1}
          nearbyPlacesAPI="GooglePlacesSearch"
          numberOfLines={1}
          // Google's own reason arrives here, for example
          // "The provided API key is invalid" or "You're calling a legacy API,
          // which is not enabled for your project".
          onFail={reason => {
            console.log('places onFail:', reason);
            setSearchError(
              typeof reason === 'string' && reason
                ? reason
                : 'There is some error with the search',
            );
          }}
          onNotFound={() => {
            console.log('places onNotFound (Google found nothing)');
            setSearchError('No places found');
          }}
          onPress={(data, details = null) => {
            // Handle selection
            const name=data.description;
            const latitude=details?.geometry?.location?.lat;
            const longitude=details?.geometry?.location?.lng;
            onSelectLocation({name:name,latitude:latitude,longitude:longitude});
            navigation.goBack();
          }}
          onTimeout={() =>
            console.warn('google places autocomplete: request timeout')
          }
          fetchDetails={true}
          predefinedPlaces={[]}
          predefinedPlacesAlwaysVisible={false}
          styles={{
            textInputContainer: styles.searchBar,
            textInput: styles.searchInput,
            listView: styles.listView,
            row: styles.row,
            separator: styles.separator,
            description: styles.description,
            poweredContainer: styles.poweredContainer,
          }}
          renderLeftButton={() => (
            // Search.svg is the padded tab-bar glyph; crop to the magnifier.
            <SearchIcon width={20} height={20} viewBox="20 3.5 24 24" />
          )}
          suppressDefaultStyles={false}
          textInputHide={false}
          textInputProps={{
            autoFocus: true,
            placeholderTextColor: colors.textMuted,
            selectionColor: colors.secondary,
          }}
          timeout={20000}
        />
      </View>
    </ScreenWrapper>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    // Was 100. Inside a plain View (no ScrollView) that padding eats the room
    // the suggestion list needs while the keyboard is open.
    paddingBottom: spacing.md,
    backgroundColor: colors.background,
  },
  // DESIGN.md "Search Header Bar": 52px glass pill with a prefix glyph.
  searchBar: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 52,
    marginHorizontal: spacing.margin,
    marginTop: spacing.sm,
    paddingLeft: spacing.lg,
    paddingRight: spacing.sm,
    borderRadius: radii.pill,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.glass,
    ...shadows.level1,
  },
  searchInput: {
    ...typography.bodyLg,
    flex: 1,
    height: 50,
    marginBottom: 0,
    paddingVertical: 0,
    paddingHorizontal: spacing.sm,
    borderRadius: 0,
    backgroundColor: 'transparent',
    color: colors.text,
  },
  listView: {
    ...card,
    // Shrink-wrap the results instead of filling the flex container.
    flexGrow: 0,
    marginHorizontal: spacing.margin,
    marginTop: spacing.md,
  },
  row: {
    backgroundColor: 'transparent',
    minHeight: 52,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.lg,
    alignItems: 'center',
  },
  separator: {
    height: 1,
    marginHorizontal: spacing.lg,
    backgroundColor: colors.borderSubtle,
  },
  description: {
    ...typography.bodyMd,
    color: colors.text,
  },
  poweredContainer: {
    backgroundColor: 'transparent',
    borderTopWidth: 1,
    borderColor: colors.borderSubtle,
    paddingVertical: spacing.sm,
    borderBottomLeftRadius: radii.card,
    borderBottomRightRadius: radii.card,
  },
  errorContainer: {
    marginHorizontal: spacing.margin,
    marginTop: spacing.md,
    padding: spacing.lg,
    borderRadius: radii.card,
    backgroundColor: colors.errorContainer,
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorText: {
    ...typography.bodyMd,
    color: colors.onErrorContainer,
    textAlign: 'center',
  },
});

export default SearchScreen;